const WAIT_RENDER_SERVER = 'SSR/WAIT_RENDER_SERVER'
const RENDER_SERVER = 'SSR/RENDER_SERVER'

export { WAIT_RENDER_SERVER, RENDER_SERVER }
